module.exports = __webpack_public_path__ + "img/c53c0d1952b4228dcba61291a26d1cd3.png";